define([
    'underscore',
    'edge/quoteandbind/common/models/Submission',
    'edge/quoteandbind/pa/models/PASubmissionDraftDataExtension'
], (_, Submission, PASubmissionDraftDataExtension)=> {
    return {
        mixinLobDraftDataExtensions: (submission)=> {
            if (submission && submission.draftData && submission.draftData.productCode === 'PersonalAuto') {
                submission.draftData.lobs = submission.draftData.lobs || {};
                submission.draftData.lobs.personalAuto = new PASubmissionDraftDataExtension(submission);
            }
        }
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/integration/quoteandbind/PolicyLineExtensionConfiguration.js
 **/